import { render, staticRenderFns } from "./Lexicon.vue?vue&type=template&id=342c0367&scoped=true"
import script from "./Lexicon.vue?vue&type=script&lang=ts"
export * from "./Lexicon.vue?vue&type=script&lang=ts"
import style0 from "./Lexicon.vue?vue&type=style&index=0&id=342c0367&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c0367",
  null
  
)

export default component.exports